import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon } from '@quipex/shared/ui';
import type { QuippyDocumentOption, QuippyMessage } from '../../../../runtime';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ul[qpx-quippy-message-document-options]',
    imports: [NgIcon, QpxButton, QpxIcon],
    templateUrl: './document-options.html',
    styleUrl: './document-options.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'm-0 mt-4 flex list-none flex-col gap-2.5 p-0',
    },
})
export class QuippyMessageDocumentOptions {
    public readonly message = input.required<QuippyMessage>();
    public readonly optionSelected = output<QuippyDocumentOption>();

    protected isSelected(option: QuippyDocumentOption): boolean {
        return this.message().selectedDocumentFileId === option.fileId;
    }

    protected isDisabled(): boolean {
        const status = this.message().documentSelectionStatus;
        return status === 'pending' || status === 'selected';
    }

    protected optionLabel(option: QuippyDocumentOption): string {
        const buildingName = option.buildingName?.trim();
        return buildingName
            ? `${option.title} - ${buildingName}`
            : option.title;
    }
}
